export const xs = 'xs';
export const sm = 'sm';
export const md = 'md';
export const lg = 'lg';
export const xl = 'xl';
export const xxl = 'xxl';

export const base = 'default';
export const primary = 'primary';
export const success = 'success';
export const warning = 'warning';
export const danger = 'danger';
export const info = 'info';

export const THEMES = Object.freeze([base, primary, success, warning, danger, info]);
